<template>
    <div id="app" v-cloak>
        <div class="container">
            <router-view />
            <MainFooter></MainFooter>
            <audio src="@/assets/audio/bg.mp3" type="audio/mpeg" loop ref="bgMusic"
            preload></audio>
        </div>
        <a href="" @click.prevent="playBgMusic(!isPlay);gaEvent('sound_btn', 'sound_toggle');"
        class="sound-toggle" :class="{'on': isPlay, 'off': !isPlay}"></a>
        <!--<div id="gotop" class="goTop"
        :class="{'show': isShowTop}" @click="scrollToTop(500)">
            Top
        </div>-->
        <StatusAlert
        :statusCode="httpStatus.statusCode"
        :triggerOpen="httpStatus.isShow"
        :statusData="httpStatus.statusData" />
        <CommonAlert
        :msg="alertData.msg"
        :triggerOpen="alertData.isShow"
        :callback="alertData.callback" />
        <Loading
        :show="pageData.isLoading"
        :percent="toChineseNumeral(loadingPercent)" />
        <Sound
        :show="isAskSound" @playBgMusic="playBgMusic" />
        <div class="dark-mask-wrapper" :class="{ 'showDMW': isShowDarkMask }" v-show="isShowDMW">
            <div class="dark-mask"></div>
        </div>
    </div>
</template>

<script>
import MainFooter from '@/components/_MainFooter.vue';
import StatusAlert from '@/components/StatusAlert.vue';
import CommonAlert from '@/components/CommonAlert.vue';
import Loading from '@/components/Loading.vue';
import Sound from '@/components/Sound.vue';
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'App',
    data() {
        return {
            isFadeout: false,
            isShowDMW: false,
            isShowDarkMask: false,
            isShowTop: false,
            loadingPercent: 0,
            isAskSound: false,
            isPlay: false,
            isPlayHeader: false,
            isfadeInActive: false,
            isLoading: true,
        };
    },
    computed: {
        isIE() {
            const { userAgent } = window.navigator;
            return (userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') > -1 || userAgent.indexOf('Edge') > -1);
        },
    },
    created() {
        if (Object.keys(this.$route.query).length === 0) this.$router.push('/?id=19');
        this.timeoutTrigger();
        this.setLoading(true);
        window.onload = () => {
            this.loadingPercent = 97;
        };
    },
    mounted() {
        if (this.$route.query.type) {
            this.isPlayHeader = true;
            this.isfadeInActive = true;
        }
        if (this.isIE) {
            this.playBgMusic(true);
        } else {
            this.isAskSound = true;
        }
    },
    methods: {
        playBgMusic(isPlay) {
            this.isPlay = isPlay;
            if (isPlay) {
                this.playAudio('bgMusic');
            } else {
                this.playAudio('bgMusic', true);
            }
            this.isAskSound = false;
            if (!this.pageData.isLoading) {
                window.setTimeout(() => {
                    this.isPlayHeader = true;
                }, 0);
                window.setTimeout(() => {
                    this.isfadeInActive = true;
                }, 1000);
            }
        },
        volBgMusic(vol) {
            const { userAgent } = window.navigator;
            this.$refs.bgMusic.volume = vol;
            if (userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1) {
                if (vol) {
                    this.playBgMusic(true);
                } else {
                    this.playBgMusic(false);
                }
            }
        },
        timeoutTrigger() {
            if (this.loadingPercent !== 100) {
                window.setTimeout(this.timeoutTrigger, 50);
            }
            if (this.loadingPercent === 100) {
                window.setTimeout(() => {
                    this.setLoading(false);

                    if (!this.isAskSound) {
                        window.setTimeout(() => {
                            this.isPlayHeader = true;
                        }, 0);
                        window.setTimeout(() => {
                            this.isfadeInActive = true;
                        }, 1000);
                    }
                }, 1000);
                return;
            }
            this.loadingPercent += 1;
        },
    },
    watch: {
        '$route.query.id': {
            handler() {
                if (!this.isPlayHeader && !this.isfadeInActive) {
                    return;
                }

                this.isPlayHeader = false;
                this.isfadeInActive = false;

                window.setTimeout(() => {
                    this.isPlayHeader = true;
                }, 0);

                window.setTimeout(() => {
                    this.isFadeout = false;
                    this.isfadeInActive = true;
                }, 1500);

                window.setTimeout(() => {
                    this.isShowDarkMask = false;
                }, 3500);

                window.setTimeout(() => {
                    this.isShowDMW = false;
                }, 4000);
            },
            deep: true,
            immediate: true,
        },
    },
    mixins: [mixinMethod],
    components: {
        MainFooter,
        StatusAlert,
        CommonAlert,
        Loading,
        Sound,
    },
};
</script>
